// export type ListContainsIds = { id: string | number }[];

import { EntityId } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { FullTagDescription } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export function providesListOld<T extends string, R extends EntityId>(
    tagType: T, // fix later, basically any string can be passed
    resultsWithId?: R[],
) {
    return resultsWithId
        ? // successful query
          [{ type: tagType, id: 'LIST' }, ...resultsWithId.map((id) => ({ type: tagType, id }))]
        : // error occurred
          [{ type: tagType, id: 'LIST' }];
}
export const defaultTags = ['UNAUTHORIZED', 'UNKNOWN_ERROR'] as const;
type DefaultTags = typeof defaultTags[number];
export type CacheItem<T, ID> = { type: T; id: ID };
export type CacheList<T, ID> = (CacheItem<T, 'LIST'> | CacheItem<T, ID> | DefaultTags)[];
/**
 * Inner function returned by `providesList` to be passed to the `provides` property of a query
 */
type InnerProvidesList<T> = <Results extends any, Error extends FetchBaseQueryError>(
    results?: any,
    error?: Error,
) => CacheList<T, Results>;

export function concatErrorCache<T, ID>(
    existingCache: CacheList<T, ID>,
    error: FetchBaseQueryError | undefined,
): CacheList<T, ID> {
    if (error && 'status' in error && error.status === 401) {
        // unauthorized error
        return [...existingCache, 'UNAUTHORIZED'];
    }

    // unknown error
    return [...existingCache, 'UNKNOWN_ERROR'];
}
//test this
export const providesList =
    <T extends string>(type: T, keyID = 'id'): InnerProvidesList<T> =>
    (results, error) => {
        // is result available?

        if (results) {
            // successful query
            /**
             * Logic:
             * if results is an array, return results, else assume results is an object and return that object in a list and map
             */
            return [
                { type, id: 'LIST' },
                ...((Array.isArray(results) && results) ||
                    [results].map((item: { [x: string]: any }) => ({ type, id: item[keyID] } as const))),
            ];
        }
        // Received an error, include an error cache item to the cache list
        return concatErrorCache([{ type, id: 'LIST' }], error);
    };
